@if (inline) {
<div class="flex gap-3 justify-around items-center h-full">
  @for (button of buttons; track button.text) {
  @if ((!button.type || button.type === 'icon') && (button.permissions == undefined || button.permissions)) {
  <button type="button" [disabled]="button.disabled" (click)="perform_action(button, $event)" [title]="button.text" class="p-2 rounded-lg hover:bg-gray-100 flex justify-center items-center transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-gray-600">
    <i [class]="button.icon" class="text-xl"></i>
  </button>
  }
  @if (button.type === 'button' && (button.permissions == undefined || button.permissions)) {
  <button type="button" [disabled]="button.disabled" (click)="perform_action(button, $event)" class="px-6 py-1.5 rounded-full w-full border border-primary text-primary hover:bg-primary hover:text-white transition-colors duration-200 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed">
    {{button.text}}
  </button>
  }
  @if (button.type === 'icon-filled' && (button.permissions == undefined || button.permissions)) {
  <button type="button" [disabled]="button.disabled" (click)="perform_action(button, $event)" [title]="button.text" class="w-9 h-9 min-w-9 min-h-9 max-w-9 max-h-9 rounded-full bg-[#EBF1FF] text-primary flex justify-center items-center hover:bg-[#dbe6fe] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
    <i [class]="button.icon" class="text-xl"></i>
  </button>
  }
  @if (button.type === 'text') {
  <span [class]="button.class">{{button.text}}</span>
  }
  }
</div>
} @else {
<div class="flex items-center gap-2 justify-end h-full w-full">
  <button (click)="toggle_dropdown($event)" class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="2" [attr.fill]="is_open ? '#3F41D1' : '#6B7280'" />
      <circle cx="2" cy="9" r="2" [attr.fill]="is_open ? '#3F41D1' : '#6B7280'" />
      <circle cx="2" cy="16" r="2" [attr.fill]="is_open ? '#3F41D1' : '#6B7280'" />
    </svg>
  </button>
  @if (!is_active) {
  <button class="inline-flex items-center justify-center rounded border border-[#A3A3A3] py-1 px-3 bg-[#E0E0E0] text-[10px] font-normal leading-none tracking-[0.02em] capitalize text-[#212121] cursor-default whitespace-nowrap" style="height:19px;">Inactive</button>
  }
</div>
}